export default "__VITE_ASSET__fde49128__"